import React from 'react';
import { connect } from 'react-redux';
import { healthInsurerSingleFetch, healthInsurerSingleUnload } from '../../lib/redux/actions/healthInsurer';
import { defaultCcsdCodeCostListFetch, defaultCcsdCodeCostListUnload, defaultCcsdCodeCostSingleRefresh } from '../../lib/redux/actions/defaultCcsdCodeCost';
import { consultantTypeListFetch } from '../../lib/redux/actions/consultantType';
import HealthInsurerSingle from './HealthInsurerSingle';

const mapStateToProps = (state) => ({
  ...state.healthInsurer,
  defaultCcsdCodeCosts: state.defaultCcsdCodeCosts.defaultCcsdCodeCosts,
  isFetchingDefaultCcsdCodeCosts: state.defaultCcsdCodeCosts.isFetchingDefaultCcsdCodeCosts,
  isLoadingMoreDefaultCcsdCodeCosts: state.defaultCcsdCodeCosts.isLoadingMoreDefaultCcsdCodeCosts,
  consultantTypes: state.consultantTypes.consultantTypes,
});

const mapDispatchToProps = {
  healthInsurerSingleFetch,
  healthInsurerSingleUnload,
  defaultCcsdCodeCostListFetch,
  defaultCcsdCodeCostListUnload,
  defaultCcsdCodeCostSingleRefresh,
  consultantTypeListFetch,
};

class HealthInsurerSingleContainer extends React.Component {
  state = {
    hasFetchedCosts: false,
  };

  componentDidMount() {
    const healthInsurerId = this.props.match.params.id;
    this.props.healthInsurerSingleFetch(healthInsurerId);
    this.props.consultantTypeListFetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      const healthInsurerId = this.props.match.params.id;
      this.props.healthInsurerSingleFetch(healthInsurerId);
      this.props.defaultCcsdCodeCostListUnload();
      this.setState({ hasFetchedCosts: false });
    }
  }

  fetchCostsIfNeeded = () => {
    if (!this.state.hasFetchedCosts) {
      const healthInsurerId = this.props.match.params.id;
      this.props.defaultCcsdCodeCostListFetch({ healthInsurer: healthInsurerId, 'exists[datedCosts]': true });
      this.setState({ hasFetchedCosts: true });
    }
  };

  handleCostSaved = (iri) => {
    if (iri) {
      this.props.defaultCcsdCodeCostSingleRefresh(iri);
    }
  };

  componentWillUnmount() {
    this.props.healthInsurerSingleUnload();
    this.props.defaultCcsdCodeCostListUnload();
  }

  render() {
    return (
      <HealthInsurerSingle
        healthInsurer={this.props.healthInsurer}
        defaultCcsdCodeCosts={this.props.defaultCcsdCodeCosts}
        isFetchingDefaultCcsdCodeCosts={this.props.isFetchingDefaultCcsdCodeCosts}
        isLoadingMore={this.props.isLoadingMoreDefaultCcsdCodeCosts}
        consultantTypes={this.props.consultantTypes}
        onCostSaved={this.handleCostSaved}
        onFetchCosts={this.fetchCostsIfNeeded}
        hasFetchedCosts={this.state.hasFetchedCosts}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthInsurerSingleContainer);
